import Icon from 'veui/components/Icon'

Icon.register({
  'trun-90-acw': {
    paths: [
      {
        d: 'M106.91 467.79c-44.56 48.26-19.07 143.71 54.2 132.72-16.33 32.9-38.91 78.34-51.53 103h51.5c45.65-93.23 91.57-166.29 71.54-214.14-19.22-54.71-91.09-57.95-125.71-21.58zm85.29 62.84c-11.79 50.45-70.39 32.47-61.51-14.5 10.74-42.13 67.93-37.04 61.51 14.5zM464 384a48 48 0 1048 48 48.05 48.05 0 00-48-48zm0 64a16 16 0 1116-16 16 16 0 01-16 16zm-81.23 14.87c-14.27-13-31.81-19.52-52.13-19.52-19.73 0-37 6.55-51.23 19.47C264.08 476 256.19 494.9 256 519v108.83c.23 24 8.12 42.83 23.45 56 14.24 12.91 31.46 19.57 51.17 19.81h.12c20.3-.24 37.81-6.92 52.06-19.84 14.61-13.17 22.26-32 22.74-56V519c-.54-24.11-8.17-43-22.77-56.13zm-22.31 162.82c-.62 22.24-10.1 32.71-29.82 32.93-19.82-.22-29.25-10.69-29.65-32.87V521.33c.4-22 9.83-32.51 29.65-32.94 19.72.43 29.2 10.89 29.82 32.92zM735.6 384A351.08 351.08 0 01630 635.38a32 32 0 01-44.8-45.71 288 288 0 00-385-427.78A289.68 289.68 0 00117 275l66.72-17a32 32 0 1115.81 62L77.91 351a32 32 0 01-39.27-37.38A352 352 0 01735.6 384z'
      }
    ],
    width: '768',
    height: '768'
  }
})
